/**
 * The EvedPay mobile shell loads the /evedpay routes in a webview and owns its own login,
 * so the SPA must never navigate them to the public login page. The persisted open-api
 * token is what separates that shell from a plain browser on the same route, which still
 * has a working login flow to fall back on.
 */
export default function isMobileWebviewSession () {
  const route = global.app && global.app.$router && global.app.$router.currentRoute
  const onWebviewRoute = !!(route && route.path && route.path.indexOf('/evedpay') === 0)

  return onWebviewRoute && !!global.localStorage.openApiToken
}



// WEBPACK FOOTER //
// ./src/core/api/mobileWebview.js